// Política de password en el cliente. Refleja la validación del backend
// (_validate_password_strength) para feedback inmediato. La autoridad final es el backend.

const SYMBOLS = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]/;

export function evaluatePassword(pw) {
  const password = pw || "";
  const checks = {
    length: password.length >= 10,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    digit: /\d/.test(password),
    symbol: SYMBOLS.test(password),
  };
  const valid = Object.values(checks).every(Boolean) && password.length <= 128;
  let level = "red";
  if (valid) {
    const diverse = password.length > 14;
    level = diverse ? "green" : "yellow";
  }
  return { checks, valid, level };
}
